<template>
  <div>
    <el-row class="nav-bar">
      <el-row class="nav-bar--left">
        <div class="nav-bar-vertical__logo">
            <gj-link route-to="/dashboard">
                <gj-icon iconfont="iconlogo" class="nav-bar--left__logo"></gj-icon>
            </gj-link>
        </div>
        <span class="watermark">M版</span>
        <el-menu
            ref="elVerticalMenu"
            menu-trigger="click"
            :default-active="activeMenuIndex"
            class="nav-bar--left__menu"
            :collapse="true"
            mode="horizontal"
            :unique-opened="true"
            @open="menuOpen"
            @close="menuClose">
          <el-submenu
              v-for="menu in userMenus"
              :index="menu.id"
              :key="menu.id"
              popper-class="gj-nar-bar--vertical-menu">
            <template #title>
                <gj-icon :iconfont="icons[menu.id]" :class="{active: activeMenuId === menu.id}"></gj-icon>
                <span slot="title" class="menu-title"  :class="{active: activeMenuId === menu.id}">{{ menu.label }}</span>
<!--              <gj-icon :iconfont="icons[menu.id]" :class="{active: $route.meta.modal === menu.label}"></gj-icon>-->
<!--              <span slot="title" :class="{active: $route.meta.modal === menu.label}">{{ menu.label }}</span>-->
            </template>
            <template #default>
              <div class="menu-col-submenu">
                <div v-for="(moduleMenu, index) in menu.children"
                     :key="moduleMenu.id"
                     :class="{'menu-col': true, 'menu-col-border': (index + 1) !== menu.children.length}">
                  <div class="menu__module--title">
                    <span>{{ moduleMenu.label }}</span>
                    <template v-if="waitOnlineTab(moduleMenu.label)">
                      <span class="wait-online">即将上线</span>
                    </template>
                  </div>
                  <div class="menu-col-submenu-label" v-for="routeMenu in moduleMenu.children"
                      :key="routeMenu.id"
                       @click="menuClick(routeMenu.label)">
                         <gj-link
                        v-if="routeMenu.component == '/tool/amazon-ad'"
                        href="https://learningconsole.amazonadvertising.com/sl/7f9bff07"
                        target="_blank"
                        class="menu__route-link">
                      <div class="menu__route-link--label">{{routeMenu.label | defaultShow}}</div>
                    </gj-link>
                    <gj-link
                        v-else
                        :route-to="routeMenu.component"
                        router-tag="div"
                        class="menu__route-link">
                      <div class="menu__route-link--label" style="position: relative;">
                        <span>{{routeMenu.label | defaultShow}}</span>
                        <gj-icon class="menu-icon-color" v-if="childrenIcons[routeMenu.id]" :iconfont="childrenIcons[routeMenu.id]"></gj-icon>
                      </div>
                    </gj-link>
                  </div>
                </div>
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </el-row>
    </el-row>
    <!-- 关闭菜单 -->
    <div class="nav-close-shade" v-if="closeShade" @click="closeMenu" ></div>
  </div>
</template>

<script>
  import {isMeaningfulMixin, keepAliveMixin, userInfoMixIn, kefuMixin} from "../../../minxins";
  import {mapGetters} from "vuex";
  import {SET_USER_GUIDE_STATE} from "@/store/mutation-types";
import { indexOf } from 'xe-utils';

  export default {
    name: "app-nav-bar-vertical",
    mixins: [userInfoMixIn, isMeaningfulMixin, keepAliveMixin, kefuMixin],
    data() {
      return {
        firstRender: true, // 判断是否是首次进入
        activeMenuIndex: '1',
        kefuLink: 'https://wp.qiye.qq.com/qidian/3009000551/2ccb4a0cbe0dee0415a3fdb8e310e1eb',
        activateMenuIndex: null, //激活的菜单index
        closeShade: false, // 遮罩
        closeShadeWidth: 0,
        icons: {
          '102': 'iconchanpin',
          '103': 'iconxiaoshou',
          '104': 'iconcaigou',
          '105': 'iconcangchu',
          '106': 'iconwuliu',
          '107': 'iconguanggao',
          '108': 'iconkefu1',
          '109': 'iconcaiwu',
          '110': 'iconfenxi',
          '111': 'icongongju',
          '112': 'iconxitong',
          '113': 'iconFBAhuojian'
        },
        childrenIcons: {
          '1070201': 'iconnew4'
        }
      }
    },
    computed: {
      ...mapGetters(['userMenus', 'userInfo', 'userGuideMenuPath', 'userGuideState']),
      // 计算当前路由页的最上级菜单id
      activeMenuId(){
        if(!this.userMenus) return ''
        for(let menu of this.userMenus){
          if(!menu.children) break
          for(let moduleMenu of menu.children){
            if(!moduleMenu.children) break
            for(let routeMenu of moduleMenu.children){
              if(routeMenu.component === this.$route.path){
                return menu.id
              }
            }
          }
        }
        return ''
      }
    },
    watch: {
      userGuideMenuPath: {
        handler(newPath, oldPath) {
          if(newPath) this.menuAuto(newPath, 'open')
          else if(!newPath && oldPath) this.menuAuto(oldPath, 'close')
        }
      }
    },
    created() {
      // 有路由重定向则设置改变
      let redirect = sessionStorage.getItem("redirect")
      if (redirect) {
        this.$router.replace(redirect);
        sessionStorage.setItem("redirect", "")
      }
    },
    methods: {
      menuClick(menuName) {
        // 在用户引导模式中，通过菜单导航跳转视为自动退出指引模式
        if(this.userGuideState) {
          this.$store.commit(SET_USER_GUIDE_STATE, false);
        }
        if (window._czc) {
          const userInfo = `${this.userInfo.tenant}+${this.userInfo.account}`;
          window._czc.push(['_trackEvent', '页面访问量', menuName, userInfo]);
        }
        this.closeMenu()
      },
      // 是否为即将上线的tab
      waitOnlineTab(label) {
        return [].includes(label);
      },
      menuOpen(index) {
        this.activateMenuIndex = index
        let times = setTimeout(() => {
          let menuList = document.querySelectorAll('.gj-nar-bar--vertical-menu')
          new Array().forEach.call(menuList, item => {
            if (item.offsetWidth > 0) {
              item.style.zIndex = 2100
            }
          })
          this.closeShade = true
          clearTimeout(times)
        }, 10);
      },
      menuClose() {
        this.closeShade = false
      },
      removeTabList(arr) {
        arr.forEach(i => {
          this.removeTabCallback(i, false)
        });
      },
      // 关闭已经激活的导航
      closeMenu() {
        this.closeShade = false
        this.$refs.elVerticalMenu.close(this.activateMenuIndex)
      },
      // 新手任务控制菜单栏展示隐藏
      menuAuto(path, type) {
        if(!this.userMenus) return false
        let menuId = ''
        for(let menu of this.userMenus){
          if(!menu.children) break
          for(let moduleMenu of menu.children){
            if(!moduleMenu.children) break
            for(let routeMenu of moduleMenu.children){
              if(routeMenu.component === path){
                menuId = menu.id
              }
            }
          }
        }
        if(menuId && type == 'open') {
          this.$refs.elVerticalMenu.open(menuId)
        }
        if(menuId && type == 'close') {
          this.$refs.elVerticalMenu.close(menuId)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
  .nav-bar--left{
    /deep/.el-submenu__title{
        height: auto !important;
        padding-bottom: 20px;
        .gj-icon {
          font-size: 18px;
        }
        span, .gj-icon{
          color: $gj-line-color-grey5;
          user-select: none;
        }
        &:hover{
          span, .gj-icon{
            color: #fff;
          }
        }
      }
      /deep/.is-opened{
        .el-submenu__title{
          span, .gj-icon{
            color: #4994fc;
            user-select: none;
          }
          &:hover{
            span, .gj-icon{
              color: #4994fc;
            }
          }
        }
      }
  }
  @media screen and (max-height: 901px) {
      /deep/.el-submenu__title{
        // height: auto !important;
        // padding-bottom: 20px;
        // span, i{
        //   color: white;
        //   user-select: none;
        // }
        i {
          display: none;
        }
      }
  }
  // 遮罩
  .nav-close-shade{
    background: #000000;
    opacity: 0.4;
    height: 100%;
    width: calc(100% - 60px);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2000;
  }
  .nav-bar--left__logo {
    margin: 0 auto;
    /deep/ .gj-icon{
      font-size: 36px;
    }
  }

  .color4994fc {
    color: #4994fc;
  }




  /deep/ .el-menu--collapse{
    width: 100%;
  }
  /deep/ .el-submenu{
    width: 100%;
  }
  .nav-bar {
    /* height: 40px; */
    /* padding: 0 20px; */
    /* background: #000; */
  }
  .nav-bar--left {
    /* height: 100%;
    padding-left: 10px; */
  }
  .nav-bar--right {
    align-items: center;
  }
  .nav-bar--left__menu {
    border: none !important;
    background: unset;
  }
  .nav-bar-vertical__logo{
      margin-top: 16px;
      margin-bottom: 6px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .watermark {
    display: block;
    width: 32px;
    height: 20px;
    border: 1px solid #D8DADD;
    border-radius: 2px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #D8DADD;
    box-sizing: border-box;
    margin: 0 auto 16px;
  }

  .nav-bar--right__notice {
    margin: 8px 22px 5px 0;
    font-size: 23px;
    color: #fff;
  }
  .nav-bar--right__notice /deep/ .el-badge__content {
    height: 14px;
    line-height: 14px;
    padding: 0 4px;
    top: 4px;
  }
  .nav-bar--right__user {
    color: #fff;
  }
  .nav-bar--right__user--avatar {
    height: 24px;
    width: 24px;
  }
  .nav-bar--right__user--name {
    margin: 0 12px;
    color: #fff;
  }
  /deep/ .el-submenu__title {
    padding: 0;
    border-bottom: none !important;
    font-size: 15px;
    font-weight: 700;
    background: $gj-background-color-bg11;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 22px !important;
    width: 100%; 
    overflow: visible;
  }
  /deep/ .el-submenu__title:hover {
    /* color: #fff !important; */
    background: $gj-background-color-bg11 !important;
  }
  /deep/ .el-submenu__title span{
    visibility: visible !important;
    height: auto !important;
    width: auto !important;
  }
  /deep/ .el-submenu__icon-arrow {
    display: none;
  }
  /deep/ .el-tabs--card > .el-tabs__header {
    margin: 4px 0 0;
    padding: 0 50px 0 20px;
  }
  /deep/ .el-tabs__item {
    height: 30px !important;
    line-height: 30px !important;
    padding: 0 16px !important;
    font-size: 14px !important;
    box-shadow: none !important;
  }
  /deep/ .el-tabs__item .el-icon-close:hover {
    background: unset;
    color: #1F6EEF;
  }
  .tab--close__dropdown {
    position: fixed;
    top: 50px;
    right: 19px;
    font-size: 16px;
    cursor: pointer;
  }
  .tab--close__dropdown:hover {
    color: #1F6EEF;
  }
  /deep/ .el-tabs__nav-wrap {
    padding-left: 0;
  }
  /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close {
    width: 14px !important;
  }
  /deep/.el-icon-paperclip::before {
    content: "\e6a3" !important;;
  }
  .wait-online {
    color: rgb(255, 63, 72);
    font-style: italic;
    transform: scale(0.85);
    display: inline-block;
    font-size: 12px;
    font-weight: normal;
  }
  /* 菜单样式 */
  .menu-col {
    position: relative;
    line-height: 2.5;
    // width: 130px;
    max-width: 180px;
    box-sizing: border-box;
  }
  .menu-col-border {
    border-right: 1px solid #b1a4a4;
  }
  .menu__module--title {
    font-weight: 400;
    color: #6e767e;
    font-size: 13px;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .menu__module--icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 8px;
    left: 14px;
  }
  .menu__route-link--label {
    color: rgba(255, 255, 255, 0.65);
    font-size: 14px;
  }
  .menu__route-link {
    width: 100%;
    justify-content: flex-start;
    text-align: left;
    /deep/ .el-link--inner{
      width: 100%;
      display: inline-block;
    }
    .menu__route-link--label{
      padding:0 30px 0 20px;
      box-sizing: border-box;
      height: 40px;
      line-height: 40px;
      &:hover{
        background-color: #EDF7FF;
      }
    }
  }
  .menu__route-link:hover .menu__route-link--label {
    color: white;
  }
  /deep/ .el-tabs__nav-next,
  /deep/ .el-tabs__nav-prev {
    line-height: 32px;
  }
  .relate-us {
    cursor: pointer;
    color: #fff;
    /* margin-right: 14px;
    margin-bottom: 4px; */
    font-size: 16px;
    padding: 0 14px;
  }

  /deep/ .el-badge{
    vertical-align: baseline;
  }
  .active{
    color: $gj-font-color-b3 !important;
    /deep/.gj-icon{
      color: $gj-font-color-b3 !important;
    }
  }

  .el-submenu__title .menu-title{
    max-width: 45px!important;
    text-align: center;
    white-space:normal;
  }
  .menu-icon-color{
    position: absolute;
    top: -1px;
    color: #F5824F;
    margin-left: 4px; 
    font-size: 28px;
  }

</style>
